import axios from 'axios';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
// api
import ApiKey from '../api/ApiKey';
import BaseApi from '../api/BaseApi';
// components
import Sidebar from './Sidebar';
import Footer from '../element/Footer';
import NavBar from '../element/NavBar';
// helpers
import { logOutIfTokenExpired } from '../helpers';
// mui
import VisibilityIcon from '@mui/icons-material/Visibility';

const MailHistory = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('global');
  const userType = Cookies.get('user_type');
  const tokenKey = Cookies.get('tokenClient');

  const [loading, setLoading] = useState(true);
  const [mailData, setMailData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const mailPerPage = 10;

  const indexOfLastMail = currentPage * mailPerPage;
  const indexOfFirstMail = indexOfLastMail - mailPerPage;
  const currentData = mailData?.slice(indexOfFirstMail, indexOfLastMail);

  const handlePageChange = pageNumber => setCurrentPage(pageNumber);

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(BaseApi + '/users/mailhistory', null, {
        headers: {
          key: ApiKey,
          token: tokenKey,
          contentType: 'application/json',
        },
      });

      setLoading(false);

      if (response.data.status === 200) {
        setMailData(response.data.response);
      }
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      }

      console.error('Cannot get mail data!', error);
    }
  };

  useEffect(() => {
    if (userType === 'candidate' || !tokenKey) {
      navigate('/auth/employer-login');
    } else {
      getData();

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate, userType]); // eslint-disable-line

  return (
    <>
      <NavBar />
      <div className='container mailHistory'>
        <div className='row'>
          <div className='col-lg-3 col-md-3'>
            <Sidebar />
          </div>
          {
            loading
              ? (
                <div className='loader-container' />
              ) : (
                <div className='col-lg-9 col-md-9 mb-5'>
                  <div className='d-flex PageHeader'>
                    <img src='/Images/employerSide/icon6color.png' alt='' />
                    <h3 className='mx-2' style={{ color: '#4864ac' }}>
                      {t('employerMailHistory.mailHistory')}
                    </h3>
                  </div>
                  <div className='MHBody PHBody mt-5'>
                    <table className='table'>
                      <thead>
                        <tr className='table-active TrFirst'>
                          <th className='' scope='col p-3'>
                            {t('employerMailHistory.username')}
                          </th>
                          <th className='' scope='col p-3'>
                            {t('employerMailHistory.companyName')}
                          </th>
                          <th className='' scope='col p-3'>
                            {t('employerMailHistory.subject')}
                          </th>
                          <th className='' scope='col p-3'>
                            {t('employerMailHistory.created')}
                          </th>
                          <th className='' scope='col p-3'>
                            {t('employerMailHistory.action')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          currentData.map((i, index) => (
                            <tr key={index} className='TrDefoult'>
                              <td className=''>{i.user_name}</td>
                              <td className=''>{i.company_name}</td>
                              <td className='pt-4 pb-4'>
                                <Link to={`/user/maildetail/${i.slug}`}>
                                  {i.subject}
                                </Link>
                              </td>
                              <td className=''>{i.created.substring(0, 10)}</td>
                              <td className='APActionButton'>
                                <button className='btn-primary button1' onClick={() => navigate(`/user/maildetail/${i.slug}`)}>
                                  <VisibilityIcon />
                                </button>
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                  <div className='mailHistoryPagination'>
                    <p className='text-muted empPaginationData'>
                      {t('pagination.NoofRecords')}{' '}
                      {mailData?.length > 0 ? indexOfFirstMail + 1 : indexOfFirstMail}-
                      {mailData ? Math.min(indexOfLastMail, mailData?.length) : 0} of{' '}
                      {mailData ? mailData?.length : 0}
                    </p>
                    <div className='d-flex justify-content-center empPaginationButton'>
                      <button
                        className='navButton1 me-2'
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        {t('pagination.Prev')}
                      </button>
                      <button
                        className='navButton1'
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={indexOfLastMail >= mailData?.length}
                      >
                        {t('pagination.Next')}
                      </button>
                    </div>
                  </div>
                </div>
              )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MailHistory;
